<template>
    <div class="identity-confirm-container">
        <veui-form
            :data="formData"
            @submit="handleSubmit"
        >
            <div class="form">
                <div class="title">注销法行宝律师资质 · 身份确认</div>
                <div class="desc">为确保是律师本人操作，请填写以下信息完成身份校验</div>
                <div class="field-box">
                    <div class="label">律师姓名</div>
                    <veui-field name="lawyerName" :rules="nameRules">
                        <veui-input
                            v-model="formData.lawyerName"
                            placeholder="请输入律师姓名"
                            :maxlength="32"
                        ></veui-input>
                    </veui-field>
                </div>
                <div class="field-box">
                    <div class="label">身份证号</div>
                    <veui-field name="idCardNo" :rules="idCardRules">
                        <veui-input
                            v-model="formData.idCardNo"
                            placeholder="请输入身份证号"
                            :maxlength="18"
                        ></veui-input>
                    </veui-field>
                </div>
                <div class="field-box">
                    <div class="label">执业证号</div>
                    <veui-field name="license" :rules="licenseRules">
                        <veui-input
                            v-model="formData.license"
                            placeholder="请输入执业证号"
                            :maxlength="32"
                        ></veui-input>
                    </veui-field>
                </div>
                <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
            </div>
            <template #actions>
                <div class="bottom-bar">
                    <button
                        class="confirm"
                        type="submit"
                        :disabled="submitting"
                    >
                        提交
                    </button>
                    <div class="back" @click="back">上一页</div>
                </div>
            </template>
        </veui-form>
        <veui-dialog
            ui="narrow"
            title="已提交"
            :open.sync="dialogOpen"
            :closable="false"
        >
            身份校验通过，已进入 7 日冷静期。冷静期内您可随时撤回申请，届满将自动注销资质。
            <template #foot>
                <veui-button
                    class="know-btn"
                    ui="primary"
                    @click="handleKnow"
                >
                    知道了
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {Input, Form, Field, Dialog, Button} from 'veui';
import {verifyDeregister} from '@/request/deregister';

export default {
    name: 'IdentityConfirmPage',

    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-dialog': Dialog,
        'veui-button': Button
    },

    data() {
        return {
            submitting: false,
            dialogOpen: false,
            errorMsg: '',
            statusInfo: null,
            nameRules: [{name: 'required', message: '请输入律师姓名'}],
            idCardRules: [{name: 'required', message: '请输入身份证号'}],
            licenseRules: [{name: 'required', message: '请输入执业证号'}],
            formData: {
                lawyerName: '',
                idCardNo: '',
                license: ''
            }
        };
    },

    methods: {
        async handleSubmit() {
            if (this.submitting) {
                return;
            }
            this.errorMsg = '';
            this.submitting = true;
            try {
                const res = await verifyDeregister({
                    lawyer_name: this.formData.lawyerName.trim(),
                    id_card_no: this.formData.idCardNo.trim(),
                    license: this.formData.license.trim()
                });
                if (+res.code === 0) {
                    this.statusInfo = res.data || null;
                    this.dialogOpen = true;
                }
                else {
                    this.errorMsg = res.msg || '校验未通过，请核对后重试';
                }
            }
            catch (error) {
                this.$toast.error('提交失败，请重试！');
            }
            finally {
                this.submitting = false;
            }
        },

        // 返回认证页
        back() {
            this.$emit('back');
        },

        // 知道了 -> 进入冷静期页
        handleKnow() {
            this.dialogOpen = false;
            this.$emit('verified', this.statusInfo);
        }
    }
};
</script>

<style lang="less" scoped>
.identity-confirm-container {
    .form {
        padding: 30px;
        background: #fff;
        border-radius: 8px;

        .title {
            color: #1e1f24;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 600;
            line-height: 18px;
        }

        .desc {
            margin-top: 12px;
            color: #848691;
            font-size: 14px;
            line-height: 18px;
        }

        .field-box {
            margin-top: 24px;
            display: flex;
            align-items: center;

            .label {
                width: 88px;
                color: #1e1f24;
                font-size: 16px;
                font-weight: 500;
            }

            .veui-input {
                width: 320px;
            }
        }

        .error-msg {
            margin-top: 16px;
            padding-left: 88px;
            color: #f5483b;
            font-size: 14px;
            line-height: 18px;
        }
    }

    ::v-deep .veui-field {
        margin: 0;
    }

    ::v-deep .veui-form-actions {
        margin: 0;
        padding: 0;
    }

    .bottom-bar {
        margin-top: 24px;
        padding: 30px;
        display: flex;
        background: #fff;
        border-radius: 8px;

        .confirm,
        .back {
            display: flex;
            height: 40px;
            width: 112px;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
        }

        .confirm {
            color: #fff;
            background-color: #05f;
            border: none;

            &[disabled] {
                opacity: .5;
            }
        }

        .back {
            margin-left: 15px;
            color: #05f;
            background-color: #fff;
            border: #05f solid 1px;
        }
    }
}

::v-deep .veui-dialog-content-foot {
    display: flex;
    justify-content: center;

    .know-btn {
        width: 180px;
        height: 40px;
    }
}
</style>
